import { useState, useRef, useEffect } from 'react';
import { MOCK_USERS } from '../../assets/mockData';
import { useMessages } from '../../contexts/MessageContext';
import MessageBubble from './MessageBubble';

export default function ChatWindow({ conversation, onBack }) {
  const [text, setText] = useState('');
  const listRef = useRef();
  const { sendMessage, recallMessage } = useMessages();

  const otherUserId = conversation.participants.find((p) => p !== 'currentUser');
  const otherUser = MOCK_USERS.find((u) => u.id === otherUserId);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [conversation.messages]);

  const handleSend = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    sendMessage(conversation.id, text.trim());
    setText('');
  };

  return (
    <div className="chat-window">
      <div className="chat-window-header">
        <button className="chat-back-btn" onClick={onBack}>
          <svg viewBox="0 0 24 24" width="20" height="20">
            <polyline points="15 18 9 12 15 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <span className="chat-window-name">{otherUser?.name || '未知用户'}</span>
      </div>

      <div className="chat-messages" ref={listRef}>
        {conversation.messages.map((msg) => (
          <MessageBubble
            key={msg.id}
            message={msg}
            isMine={msg.senderId === 'currentUser'}
            onRecall={(id) => recallMessage(conversation.id, id)}
          />
        ))}
      </div>

      <form className="chat-input-bar" onSubmit={handleSend}>
        <input
          type="text"
          className="chat-input"
          placeholder="输入消息..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <button type="submit" className="chat-send-btn" disabled={!text.trim()}>
          发送
        </button>
      </form>
    </div>
  );
}
